// lib/chat/anhangOeffnen.ts
// #549: Unterlagen aus dem Chat öffnen — Verweise (Drive, Mail-Anhang, Ticket-Anhang) mit
// den Rechten des Öffnenden laden, Chat-Dateien aus dem Bucket. Öffnet im neuen Tab.
import { supabase } from '../supabase/client';
import { ladeDateiBlob } from '../dokumente/aktenschrankApi';
import { ladeAnhangBlob } from '../emails/anhangDatei';
import { bildUrl } from './api';
import type { ChatAnhang } from './nachrichten';

/** Tab sofort öffnen (sonst blockt der Browser das Pop-up nach dem await), dann befüllen. */
async function inNeuemTab(lade: () => Promise<string | null>): Promise<boolean> {
  const fenster = window.open('', '_blank');
  try {
    const url = await lade();
    if (!url) { fenster?.close(); return false; }
    if (fenster) fenster.location.href = url; else window.location.assign(url);
    return true;
  } catch (e) {
    console.error('Unterlage öffnen fehlgeschlagen', (e as Error).message);
    fenster?.close();
    return false;
  }
}

/** Verweis öffnen; false = ging nicht (keine Rechte, Datei weg). */
export function oeffneChatAnhang(a: ChatAnhang): Promise<boolean> {
  return inNeuemTab(async () => {
    if (a.quelle === 'drive') return URL.createObjectURL(await ladeDateiBlob(a.id, a.typ ?? null));
    if (a.quelle === 'email') return URL.createObjectURL(await ladeAnhangBlob(a.id, a.typ ?? null));
    if (!a.pfad) return null;
    const { data, error } = await supabase.storage.from('ticket-anhaenge').createSignedUrl(a.pfad, 300);
    if (error) throw error;
    return data?.signedUrl ?? null;
  });
}

/** Im Chat hochgeladene Datei öffnen. */
export function oeffneChatDatei(path: string): Promise<boolean> {
  return inNeuemTab(() => bildUrl(path));
}

/** Chat-Datei als File laden (für „In Akte ablegen“). */
export async function ladeChatDatei(path: string, name: string): Promise<File> {
  const url = await bildUrl(path);
  if (!url) throw new Error('Datei konnte nicht geladen werden');
  const res = await fetch(url);
  if (!res.ok) throw new Error('Datei konnte nicht geladen werden');
  const blob = await res.blob();
  return new File([blob], name, { type: blob.type || 'application/octet-stream' });
}
